import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['card', 'resumeIdField', 'errorMessage']
  static values = { selectedId: Number }

  // The selected/unselected colours come from the markup so both brands can drive
  // this file. A class named only in here sits outside every Tailwind content
  // glob, so Workays' bundle would never compile the endeavour defaults anyway.
  static classes = ['selected', 'unselected']

  static DEFAULT_CLASSES = {
    selected: ['border-endeavour-500', 'bg-endeavour-50'],
    unselected: ['border-gray-200', 'bg-white']
  }

  classesFor(name) {
    const capitalised = name.charAt(0).toUpperCase() + name.slice(1)
    if (this[`has${capitalised}Class`]) return this[`${name}Classes`]

    return this.constructor.DEFAULT_CLASSES[name]
  }

  connect() {
    this.highlightSelected()
  }

  select(event) {
    const card = event.currentTarget
    const resumeId = card.dataset.resumeId

    if (!resumeId) return

    this.selectedIdValue = parseInt(resumeId, 10)

    // Update hidden field
    if (this.hasResumeIdFieldTarget) {
      this.resumeIdFieldTarget.value = resumeId
    }

    this.highlightSelected()
  }

  highlightSelected() {
    const on = this.classesFor('selected')
    const off = this.classesFor('unselected')

    this.cardTargets.forEach((card) => {
      const selected = parseInt(card.dataset.resumeId, 10) === this.selectedIdValue

      card.classList.add(...(selected ? on : off))
      card.classList.remove(...(selected ? off : on))
    })
  }

  clearError() {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.classList.add('hidden')
      this.errorMessageTarget.textContent = ''
    }
  }

  handleUploadError(event) {
    const { message } = event.detail
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.textContent = message
      this.errorMessageTarget.classList.remove('hidden')
    }
  }
}
